import React from 'react';
import styles from './M_ProfileMobileTabsMenu.module.css';
import A_ProfileMenuSelectButton from '@/components/A_Atoms/A_ProfileMenuSelectButton/A_ProfileMenuSelectButton';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

type ProfileTab =
  | 'profile'
  | 'security'
  | 'privacy'
  | 'notifications'
  | 'billing'
  | 'wallet';

interface M_ProfileMobileTabsMenuProps {
  isOpen: boolean;
  onClose: () => void;
  activeTab: ProfileTab;
  onTabChange: (tab: ProfileTab) => void;
  onLogout: () => void;
}

export default function M_ProfileMobileTabsMenu({
  isOpen,
  onClose,
  activeTab,
  onTabChange,
  onLogout,
}: M_ProfileMobileTabsMenuProps) {
  const { language } = useLanguage();

  if (!isOpen) return null;

  const handleTabClick = (tab: ProfileTab) => {
    onTabChange(tab);
    onClose();
  };

  const handleLogout = () => {
    onLogout();
    onClose();
  };

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.sheet} onClick={e => e.stopPropagation()}>
        <div className={styles.handle} />
        <div className={styles.content}>
          <div className={styles.menu_wrapper}>
            <A_ProfileMenuSelectButton
              variant='mobile'
              icon={<Q_Icon.ProfileIcon width={24} height={24} fill='none' />}
              text={getTranslation(language, 'profileMenu.tabs.profile')}
              active={activeTab === 'profile'}
              onClick={() => handleTabClick('profile')}
            />
            <A_ProfileMenuSelectButton
              variant='mobile'
              icon={<Q_Icon.SecurityIcon width={24} height={24} fill='none' />}
              text={getTranslation(language, 'profileMenu.tabs.security')}
              active={activeTab === 'security'}
              onClick={() => handleTabClick('security')}
            />
            <A_ProfileMenuSelectButton
              variant='mobile'
              icon={<Q_Icon.PrivacyIcon width={24} height={24} fill='none' />}
              text={getTranslation(language, 'profileMenu.tabs.privacy')}
              active={activeTab === 'privacy'}
              onClick={() => handleTabClick('privacy')}
            />
            <A_ProfileMenuSelectButton
              variant='mobile'
              icon={
                <Q_Icon.NotificationsIcon width={24} height={24} fill='none' />
              }
              text={getTranslation(language, 'profileMenu.tabs.notifications')}
              active={activeTab === 'notifications'}
              onClick={() => handleTabClick('notifications')}
            />
            <A_ProfileMenuSelectButton
              variant='mobile'
              icon={<Q_Icon.BillingIcon width={24} height={24} fill='none' />}
              text={getTranslation(language, 'profileMenu.tabs.billing')}
              active={activeTab === 'billing'}
              onClick={() => handleTabClick('billing')}
            />
            <A_ProfileMenuSelectButton
              variant='mobile'
              icon={<Q_Icon.BillingIcon width={24} height={24} fill='none' />}
              text={getTranslation(language, 'profileMenu.tabs.wallet')}
              active={activeTab === 'wallet'}
              onClick={() => handleTabClick('wallet')}
            />
          </div>
          <div className={styles.logout_wrapper}>
            <A_ProfileMenuSelectButton
              variant='mobile'
              icon={<Q_Icon.LogoutIcon width={24} height={24} fill='none' />}
              text={getTranslation(language, 'profileMenu.logout')}
              onClick={handleLogout}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
